export const iconFontAwesomeMapsHouse = (
	<i className="fa-solid fa-house"></i>
);
